ShareButtons = LP.module 'ShareButtons'
import { loadFacebookScript, loadPinterestScript } from 'js/on_page_ready'

ShareButtons.site = ->
  $(document).off 'click', 'a[data-share-service]'
  $(document).on 'click', 'a[data-share-service]', (e) ->
    e.preventDefault()

    if $(@).attr('href') is '#'
      from_share_url = false
      href = if $(@).data('shareUrl') is 'site'
        LP.config.member_sharing_url
      else if $(@).data('shareUrl') is 'none'
        ''
      else if /^https?\:/.test $(@).data('shareUrl')
        from_share_url = true
        $(@).data('shareUrl')
      else
        ShareButtons.url()

      message = $(@).data('shareMessage') || document.title
      caption = $(@).data('shareCaption')
      description = $(@).data('shareDescription')
      image = $(@).data('shareImage') || $('meta[property="og:image"]').attr('content') || $(@).data('share-image')
      if image?
        image = ShareButtons.processImageURL(image)
      original_thumbnail = $(@).parents('.panel-review').find('#share-buttons-real-thumbnail')

      if from_share_url == true && original_thumbnail.length > 0
        original_thumbnail_src = ShareButtons.processImageURL(original_thumbnail.attr('src'))
        resource_thumbnail = $(@).parents('.panel-review').find('.resource-img').attr('src')
        resource_thumbnail_src = ShareButtons.processImageURL(resource_thumbnail)
        if typeof(original_thumbnail) != 'undefined' && /\/original\//.test(original_thumbnail_src)
          image = original_thumbnail_src
        else if typeof(resource_thumbnail) != 'undefined'
          image = resource_thumbnail_src

      encodedHref = encodeURIComponent href
      encodedMessage = encodeURIComponent message
      encodedDescription = encodeURIComponent description
      encodedImage = encodeURIComponent image
      image_type = 'image/jpeg'
      if /\.png/.test(image)
        image_type = 'image/png'
      else if /\.gif/.test(image)
        image_type = 'image/gif'

      if $(@).data('shareService') is 'facebook'
        loadFacebookScript().then(() ->
          e.preventDefault()
          fbObject = if image?
            {
              'og:url': href
              'og:title': message
              'og:description': description
              'og:image': image
              'og:image:type': image_type
            }
          else
            {
              'og:url': href
              'og:title': message
              'og:description': description
            }
          callback = () -> {}
          FB.ui({
            method: 'share_open_graph'
            action_type: 'og.shares'
            action_properties: JSON.stringify(
              ref: 'ShareThePlanet'
              object: fbObject
            )
          }, callback )
        )

      else if $(@).data('shareService') is 'twitter'
        $(@).attr 'href', "https://twitter.com/intent/tweet?url=#{encodeURIComponent(href)}&text=#{encodeURIComponent(LP.config.twitter_message || message)}&via=LessonPlanet"
      else if $(@).data('shareService') is 'linkedin'
        $(@).attr 'href', "http://www.linkedin.com/shareArticle?mini=true&url=#{href}&title=#{encodedMessage}&ro=false&summary=#{encodedDescription}&source="
      else if $(@).data('shareService') is 'pinterest'
        e.preventDefault()
        el = $(@)
        loadPinterestScript().then(() ->
          if typeof(window.event) == "undefined"
            window.event = e

          url = "https://www.pinterest.com/pin/create/button/?url=#{href}&media=#{image}&description=#{ShareButtons.pinterest_message(message)}&custom=true"
          ShareButtons.openPopup(url, el.data('popupTarget'), 850, 640)
        )

    if $(@).data('popupTarget')? && $(@).data('shareService') != 'pinterest'
      e.preventDefault()
      ShareButtons.openPopup($(@).attr('href'), $(@).data('popupTarget'))

ShareButtons.processImageURL = (image_url) ->
  return image_url if typeof(image_url) == 'undefined'
  if String(image_url).substring(0, 2) == '//'
    image_url = window.location.protocol + image_url
  else if String(image_url).substring(0, 1) == '/'
    image_url = window.location.origin + image_url
  image_url = "https:#{image_url}" unless /^http/.test(image_url)
  image_url

ShareButtons.site_url = 'http://www.lessonplanet.com'

ShareButtons.pinterest_message = (message) ->
  LP.config.pinterest_message || message

ShareButtons.url = ->
  string_starting_with = (str, pre) ->
    return '' if !str or str.length == 0
    return str if str.substring(0, 1) == pre
    pre + str
  path = string_starting_with(window.location.pathname, '/')
  query = string_starting_with(location.search, '?')
  share = ''
  ShareButtons.site_url + path + query + share

ShareButtons.windowObjectReference = null
ShareButtons.openPopup = (url, title, width = 600, height = 420) ->
  if not ShareButtons.windowObjectReference? or ShareButtons.windowObjectReference.closed
    left = ((screen.width / 2) - (width / 2)) + window.screenLeft
    top = ((screen.height / 2.5) - (height / 2))

    ShareButtons.windowObjectReference = window.open(url, title, "resizable,scrollbars,status,width=" + width + ",height=" + height + ",top=" + top + ",left=" + left)
  else
    ShareButtons.windowObjectReference.focus()
